export { default } from './RegisterDistributor';
